

const route = {
    login: '/login',
    otpveryfication: '/otpveryfication',

    comList: '/a/companylist',
    amtcPoTrackingList: '/a/poTrackingList',
    addPot: '/a/addPot',
    editPot: '/a/editPot',


    comPoTrackingList: '/c/poTrackingList',

    accComList: '/acc/companylist',
    accPoTrackingList: '/acc/poTrackingList',
    accEditPotInvPage: '/acc/editPotInvPage',
}

export default route
